// extracted by mini-css-extract-plugin
export default {"input":"Input_input__e0KNl","error":"Input_error__et7XU"};